<template>
  <div class="container">
    <div class="lrs-rules">
     <div class="color_bg"></div>
        <div class="lrs_content">
            <div class="color_pinkbg"></div>
            <div class="six_person"></div>
                <ul class="person_image" >
                    <li v-for="(item,index) in personNum.Sixperson" :key="index"  >
                        <img :src="item.src" alt="">
                        <span class="text" >{{item.text}}</span>
                    </li>
                </ul>
                <div class="info_text">
                    <p class="info_item">游戏人数：
                        <span >6人</span>
                    </p>
                    <p class="info_item">胜负判定：</p>
                    <p class="info_infos">屠边局，达到以下任何一条件即游戏结束</p>
                    <p class="info_infos">{1}所有平民死亡 </p>
                    <p class="info_infos">{2}所有神职死亡 </p>
                    <p class="info_infos">{3}所有狼人死亡</p>
                    <p class="info_item">本局规则：</p>
                    <p class="info_infos">{1}狼人可自爆</p>
                    <p class="info_infos">{2}守卫可以守卫自己</p>
                    <p class="info_infos">{3}守卫不能连续两晚守护同一人 </p>
                </div>
                <p class="line_image"></p>
            <div class="nine_person"></div>
                <ul class="person_image" >
                    <li v-for="(item,index) in personNum.Nineperson" :key="index"  >
                        <img :src="item.src" alt="">
                        <span class="text" >{{item.text}}</span>
                    </li>
                </ul>
                <div class="info_text">
                    <p class="info_item">游戏人数：
                        <span>9人</span>
                    </p>
                    <p class="info_item">胜负判定：</p>
                    <p class="info_infos">屠边局，达到以下任何一条件即游戏结束</p>
                    <p class="info_infos">{1}所有平民死亡 </p>
                    <p class="info_infos">{2}所有神职死亡 </p>
                    <p class="info_infos">{3}所有狼人死亡</p>
                    <p class="info_item">本局规则：</p>
                    <p class="info_infos">{1}狼人可自爆</p>
                    <p class="info_infos">{2}女巫首夜可以自救</p>
                    <p class="info_infos">{3}女巫的解药和毒药不可在同一晚使用</p>
                    <p class="info_infos">{4}猎人被女巫毒杀时不能发动技能 </p>
                    </div>
                <p class="line_image"></p>
            <div class="twelve_person_one"></div>
                <ul class="person_image" >
                    <li v-for="(item,index) in personNum.Twelveperson" :key="index"  >
                        <img :src="item.src" alt="">
                        <span class="text">{{item.text}}</span> 
                    </li>
                </ul>
                <div class="info_text">
                    <p class="info_item">游戏人数：
                        <span >12人</span>
                    </p>
                    <p class="info_item">胜负判定：</p>
                    <p class="info_infos">屠边局，达到以下任何一条件即游戏结束</p>
                    <p class="info_infos">{1}所有平民死亡 </p>
                    <p class="info_infos">{2}所有神职死亡 </p>
                    <p class="info_infos">{3}所有狼人死亡</p>
                    <p class="info_item">本局规则：</p>
                    <p class="info_infos">{1}狼人可自爆</p>
                    <p class="info_infos">{2}白痴被票出局时免死一次 </p>
                    <p class="info_infos">{3}白痴发动技能后仍可游戏、发言，但不再有投票权 </p>
                    <p class="info_infos">{4}白痴使用技能后仍可吃刀、吃毒、死亡</p>
                    <p class="info_infos">{5}女巫首夜可自救</p>
                </div>
                
                <div class="twelve_person_two"></div>
                <ul class="person_image" >
                    <li v-for="(item,index) in personNum.Twelveperson_two" :key="index"  >
                        <img :src="item.src" alt="">
                        <span class="text">{{item.text}}</span> 
                    </li>
                </ul>
                <div class="info_text">
                    <p class="info_item">游戏人数：
                        <span >12人</span>
                    </p>
                    <p class="info_item">胜负判定：</p>
                    <p class="info_infos">屠边局，达到以下任何一条件即游戏结束</p>
                    <p class="info_infos">{1}所有平民死亡 </p>
                    <p class="info_infos">{2}所有神职死亡 </p>
                    <p class="info_infos">{3}所有狼人死亡</p>
                    <p class="info_item">本局规则：</p>
                    <p class="info_infos">{1}狼人可自爆</p>
                    <p class="info_infos">{2}守卫可以守卫自己 </p>
                    <p class="info_infos">{3}守卫不能连续两晚守护同一个人 </p>
                    <p class="info_infos">{4}女巫首夜可以自救</p>
                </div>
                <p class="line_image"></p>
            <div class=" Sheriff"></div>
                <div class="info_text">
                    <p class="info_infos">1.警长竞选仅在12人局进行</p>
                    <p class="info_infos">2.警长竞选，每局仅一次</p>
                    <p class="info_infos">3.警长特权：</p>
                    <p class="info_infos">{1}拥有1.5倍投票权 </p>
                    <p class="info_infos">{2}警长安排发言-警左警右</p>
                    <p class="info_infos">（警左是你的上面人发言.警右是从你下面的那个人发言)</p>
                    <p class="info_infos">{3}警长归票位发言</p>
                    <p class="info_infos">4.警长由玩家自愿参加竞选</p>
                    <p class="info_infos">{1}参加竞选的玩家，为“上警”</p>
                    <p class="info_infos">{2}未参与的玩家，为“警下”</p>
                    <p class="info_infos">5.警上玩家按照顺序轮流发言，中途可以退出竞选 </p>
                    <p class="info_infos">(又称“退水”)</p>
                    <p class="info_infos">{1}进入投票环节不可退水</p>
                    <p class="info_infos">6.警上玩家结束发言，警下玩家投票选举警长</p>
                    <p class="info_infos">{1}若平票，则平票双方进行发言PK投票</p>
                    <p class="info_infos">{2}若三轮仍为平票，则本局没有警长</p>
                    <p class="info_infos">7.警长竞选结束，按照白天环节正常游戏</p>
            </div>
            <p class="line_image"></p>
            <div class="escape"></div>
                <div class="info_text">
                    <p class="info_infos">1.开局后离开对局，视为逃跑</p>
                    <p class="info_infos"> 2.惩罚：逃跑次数+1 </p>  
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import langrenImages from '../../assets/images/lrsimages/rules/lrs_langren_img@2x.png'
import baichiImages  from '../../assets/images/lrsimages/rules/lrs_baichi_img@2x.png'
import pingminImages from '../../assets/images/lrsimages/rules/lrs_pingming_img@2x.png'
import shouweiImages from '../../assets/images/lrsimages/rules/lrs_shouwei_img@2x.png'
import nvwuImages from '../../assets/images/lrsimages/rules/lrs_nvwu_img@2x.png'
import lierenImages from '../../assets/images/lrsimages/rules/lrs_lieren_img@2x.png'
import yuyanjiaImages from '../../assets/images/lrsimages/rules/lrs_yuyanjia_img@2x.png'
export default {
    data(){
        return{
            personNum:{
                Sixperson:[],
                Nineperson:[],
                Twelveperson:[],
                Twelveperson_two:[]
            } 
        }
    },
    created(){
        document.getElementsByTagName('title')[0].innerText = "游戏规则" ;
        const imgArr =[];
        imgArr.push(
             {"src":langrenImages,"text":'狼人x2'},
             {"src":pingminImages,"text":'平民x2'},
             {"src":yuyanjiaImages,"text":'预言家x1'},
             {"src":shouweiImages,"text":'守卫x1'}
        );
        this.personNum.Sixperson = JSON.parse(JSON.stringify(imgArr)) 
        const nineImg =[{"src":lierenImages,"text":'猎人x1'}]
        const nine = [...imgArr,...nineImg]
        this.personNum.Nineperson = JSON.parse(JSON.stringify(nine))
        this.personNum.Nineperson.forEach((item,index)=>{
            if(index==0){
                item.text =`狼人x3`
            }else if(index==1){
                item.text ='平民x3'
            }else if(index==3){
                item.src=nvwuImages;
                item.text ="女巫x1"
            }
        })
       const twelveImg = [{"src":baichiImages,"text":'白痴x1'}]
       const twelve =[...this.personNum.Nineperson,...twelveImg]
       this.personNum.Twelveperson =JSON.parse(JSON.stringify(twelve));
        this.personNum.Twelveperson.forEach((item,index)=>{
            if(index==0){
                item.text ='狼人x4'
            }else if(index==1){
                item.text ='平民x4'
            }
        })
     const twelveImg_shouwei = [{"src":shouweiImages,"text":'守卫x1'}]
     const twelve_shouwei =[...this.personNum.Nineperson,...twelveImg_shouwei]
     this.personNum.Twelveperson_two =JSON.parse(JSON.stringify(twelve_shouwei));
     this.personNum.Twelveperson_two.forEach((item,index)=>{
            if(index==0){
                item.text ='狼人x4'
            }else if(index==1){
                item.text ='平民x4'
            }
        })
    }
   
}
</script>

<style scoped>
@import '../../assets/css/base.css';
.lrs-rules{
    background: url('../../assets/images/lrsimages/rules/lrs_bg3_icon@2x.png')no-repeat ;
    background-size: 100% 100%;
    width:100vw;
    height: 33.35rem;
    position: relative;
    padding-top:7.5rem;
    padding-left:0.2rem
}
.color_bg{
    position: absolute;
    top:14.45rem;
    left:0;
    width:100vw;
    height:105.5rem;
    background-color: rgba(160,109,234,1);

}
.lrs-rules .lrs_content {
    display: inline-block;
    background: url('../../assets/images/lrsimages/rules/lrs_kaung_bg@2x.png')no-repeat ;
    background-size: cover;
    width:18.25rem;
    height: 25.95rem;
    text-align: center;
    position: relative;
}
.lrs-rules .lrs_content .color_pinkbg{
    position: absolute;
    top:25.95rem;
    left:0.65rem;
    height: 86.5rem;
    width:16.95rem;
    border-left:0.15rem solid rgba(135,45,243,1);
    border-right:0.15rem solid rgba(135,45,243,1);
    background:rgba(252,241,255,1)
}
.lrs-rules .lrs_content .color_pinkbg:after{
    content:'';
    position:absolute;
    left:0;
    top:38.625rem;
    width:100%;
    height:0.5rem;
    background:rgba(228,202,252,1);
}
.lrs-rules .lrs_content .person_image,
.lrs-rules .lrs_content .info_text{
    padding-left:1.25rem;
    padding-right:0.75rem;
    position: relative;
    z-index:100;
}
.lrs-rules .lrs_content .six_person{
    display: inline-block;
    background: url('../../assets/images/lrsimages/rules/lrs_6ren_bg@2x.png')no-repeat ;
    background-size: cover;
    width:9.5rem;
    height: 1.95rem;
    text-align: center;
    margin-top:2rem;
}
.lrs-rules .lrs_content .nine_person{
    display: inline-block;
    background: url('../../assets/images/lrsimages/rules/lrs_9ren_bg@2x.png')no-repeat ;
    background-size: cover;
    width:9.5rem;
    height: 1.95rem;
    text-align: center;
    margin-top:2rem;
}
.lrs-rules .lrs_content .twelve_person_one{
    display: inline-block;
    background: url('../../assets/images/lrsimages/rules/idiocy.png')no-repeat ;
    background-size: cover;
    width:9.5rem;
    height: 1.95rem;
    text-align: center;
     margin-top:2rem;
    position: relative;
    z-index:100;
}
.lrs-rules .lrs_content .twelve_person_two{
    display: inline-block;
    background: url('../../assets/images/lrsimages/rules/guard.png')no-repeat ;
    background-size: cover;
    width:9.5rem;
    height: 1.95rem;
    text-align: center;
     margin-top:2rem;
    position: relative;
    z-index:100;
}

.lrs-rules .lrs_content .person_image{
   display: flex;
   flex-wrap:wrap;
   flex-direction:row;   
}
.lrs-rules .lrs_content .person_image li{
    width:3.6rem;
    height: 3.6rem;
    margin-right:0.35rem;
    position: relative;
    margin-top:0.45rem;
}
.lrs-rules .lrs_content .person_image li img{
    width:100%;
    height: 100%;
}
.lrs-rules .lrs_content .person_image li .text{
    display: inline-block;
    font-size:0.6rem;
    font-family:"PingFangSC-Regular,PingFang SC";
    font-weight:400;
    color:rgba(255,255,255,1);
    width: 100%;
    text-align: center;
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    bottom:0.25rem;   
}
.lrs-rules .lrs_content .info_text .info_item{
    font-size:0.65rem;
    font-family:"PingFangSC-Medium,PingFang SC";
    font-weight:500;
    color:rgba(87,37,164,1);
    line-height:0.85rem;
    text-align: left;
    margin-top:0.45rem;
}
.lrs-rules .lrs_content  .info_item span,
.lrs-rules .lrs_content .info_text .info_infos{
    text-align: left;
    font-size:0.6rem;
    font-family:"PingFangSC-Medium,PingFang SC";
    font-weight:500;
    color:rgba(87,37,164,.5);
    line-height:0.825rem;
}
.lrs-rules .lrs_content .line_image{
    background: url('../../assets/images/lrsimages/rules/lrs_fenge_bg@2x.png')no-repeat ;
    background-size: 100% 100%;
    width:16.65rem;
    height: 0.6rem;
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    margin-top:1.2rem;
    margin-bottom:1.2rem;
}
.lrs-rules .lrs_content .Sheriff{
    display: inline-block;
    background: url('../../assets/images/lrsimages/rules/lrs_jinzhang_bg@2x.png')no-repeat ;
    background-size: cover;
    width:10.675rem;
    height: 1.95rem;
    text-align: center;
     margin-top:2rem;
    position:relative;
    z-index:100
}
.lrs-rules .lrs_content .escape{
    display: inline-block;
    background: url('../../assets/images/lrsimages/rules/lrs_taopao_bg@2x.png')no-repeat ;
    background-size: cover;
    width:10.675rem;
    height: 1.95rem;
    text-align: center;
     margin-top:2rem;
    position:relative;
    z-index:100
}
</style>


// WEBPACK FOOTER //
// src/components/lrs/lrs_rules.vue